import { render, staticRenderFns } from "./DurationStartEnd.vue?vue&type=template&id=2f211e8e&scoped=true"
import script from "./DurationStartEnd.vue?vue&type=script&lang=js"
export * from "./DurationStartEnd.vue?vue&type=script&lang=js"
import style0 from "./DurationStartEnd.vue?vue&type=style&index=0&id=2f211e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f211e8e",
  null
  
)

export default component.exports